$( document ).ready(function () {
  if ($('.campaign-dashboard').length) {
    initDashboard();
  }
});

// Wrapper for all social mParticle events sent in this file
function sendShareAnalyticEvent(shareMethod) {
  var eventData = {
    'Share Location': 'Dashboard',
    'Share Method': shareMethod
  };
  SC.analytics.mp.sendEvent('Challenge_Spring19 - Share', 'social', eventData, shareMethod);
}

function initDashboard() {
  var $dashboard = $('.campaign-dashboard');

  launchCountdown();

  // Set content section nav events
  $dashboard.find('.campaign-dashboard-content-nav-item').click(function () {
    var section = $(this).attr('section');
    showDashboadSection(section);
    SC.analytics.mp.sendEvent('Challenge_Spring19 - View Progress Details', 'navigation', {'Section Viewed': section}, section);
  });

  showDashboadSection('timeline');

  // Copy link
  $dashboard.find('.campaign-dashboard-share-link button').click(function () {
    var $input = $(this).prev('input');
    $input[0].select();

    document.execCommand('Copy');

    confirmation(null, 'Link copied to clipboard.');
    sendShareAnalyticEvent('Link Copied');
  });

  $dashboard.find('.campaign-share-icon-twitter').click(function (e) {
    e.preventDefault();
    // 500x285 is the size of the twitter popup we're going to use
    SC.utils.popupCenter($(this).attr('href'), 'Twitter', 550, 285);
    sendShareAnalyticEvent('Twitter');
  });

  $dashboard.find('.campaign-share-icon-facebook').click(function (e) {
    e.preventDefault();
    sendShareAnalyticEvent('Facebook');
  });

  $dashboard.find('.campaign-share-icon-email').click(function (e) {
    sendShareAnalyticEvent('Email');
    if ($dashboard.hasClass('pre-campaign')) {
      e.preventDefault();
      SC.inviteModal.show();
    } else {
      sendShareAnalyticEvent('Email');
    }
  });

  // Social media swiper
  new Swiper('.campaign-dashboard-social-images', {  
    slidesPerView: 'auto',
    spaceBetween: 0,
    freeMode: true,
    autoResize: false
  });

  // Setup the invite overlay
  SC.inviteModal = new InviteOverlay($('.invite_overlay_container'));

  if ($dashboard.hasClass('show-invite-modal')) {
    SC.inviteModal.show();
  }
}

function showDashboadSection(section) {
  var $dashboardContent = $('.campaign-dashboard-content');
  $dashboardContent.find('.campaign-dashboard-content-nav-item.selected')
    .removeClass('selected');

  $dashboardContent.find('.campaign-dashboard-content-nav-item[section=' + section + ']')
    .addClass('selected');

  $dashboardContent.find('.campaign-dashboard-content-section')
    .hide();

  $dashboardContent.find('.campaign-dashboard-content-section[section=' + section + ']')
    .show();
}

function launchCountdown() {
  // Setup countdown
  var $countdownElm = $('.campaign-dashboard.pre-campaign .campaign-dashboard-countdown');

  if ($countdownElm.length) {
    setInterval(function () {
      var timeSections = {
        day: 0,
        hour: 0,
        min: 0,
        sec: 0
      };

      var seconds = parseInt($countdownElm.data('seconds'), 0);

      if (seconds >= 0) {
        $countdownElm.data('seconds', (seconds - 1));

        timeSections.sec = seconds;

        timeSections.day = Math.floor(timeSections.sec / (60 * 60 * 24));
        timeSections.sec -= timeSections.day * (60 * 60 * 24);

        timeSections.hour = Math.floor(timeSections.sec / (60 * 60));
        timeSections.sec -= timeSections.hour * (60 * 60);

        timeSections.min = Math.floor(timeSections.sec / 60);
        timeSections.sec -= timeSections.min * 60;

        var textSections = [];

        for (var unit in timeSections) {
          if (Object.prototype.hasOwnProperty.call(timeSections, unit)) {
            textSections.push(timeSections[unit] + ' ' + unit + (timeSections[unit] !== 1 ? 's' : ''));
          }
        }

        $countdownElm.html(textSections.join(' : '));
      } else {
        location.reload();
      }
    }, 1000);
  }
}

/**
 * The class sets up the invite modal
 *
 * @param {object} $element element
 * @returns {void}
 */
function InviteOverlay($element) {
  var self = this;

  this.$element   = $element;
  this.$close     = this.$element.find('.invite-close');

  this.show = function () {
    this.$element.show();
  };

  this.hide = function () {
    this.$element.hide();
    this.restoreDefaults();
  };

  this.restoreDefaults = function () {
    this.$element.find('.invite-input-container').empty();
    // Create 2 inputs to start with
    for (var i = 0; i < 2; i++) {
      this.addEmailInput();
    }
  };

  this.clearFormErrors = function () {
    this.$element.find('.field-error').removeClass('field-error');
  };

  this.addEmailInput = function () {
    var $inputContainer = this.$element.find('.invite-input-container');
    var $fieldContainer = $('<div>', { class: 'field-container' });
    var $input = $('<input>', {
      type: 'email',
      placeholder: "Add friend's email address"
    });

    $fieldContainer.append($input);
    $inputContainer.append($fieldContainer);
  };

  this.fieldError = function ($input, error) {
    $input.parent().addClass('field-error');

    // If there isn't a error message element, create one
    var $messageElm = $input.next('.field-error-message');
    if ($messageElm.length === 0) {
      $messageElm = $('<div>', { class: 'field-error-message' });
      $input.after($messageElm);
    }

    $messageElm.html(error);
  };

  // Process Form
  this.submitForm = function () {
    var $form = this.$element.find('form');

    this.clearFormErrors();

    var emails = {};
    var $emailInputs = this.$element.find('input[type=email]');

    $emailInputs.each(function (index, input) {
      var value = input.value.trim();
      if (value !== '') {
        emails[index] = value;
      }
    });

    if ($.isEmptyObject(emails)) {
      this.fieldError($emailInputs.first(), 'No emails provided');
      $emailInputs.first().focus();
    }

    $.ajax({
      url: $form.attr('action'),
      type: 'post',
      dataType: 'json',
      data: { emails: emails },
      success: function (data) {
        if (data.success) {
          var message = 'Yay! You just invited '
                  + data.emails_sent
                  + ' '
                  + ((data.emails_sent > 1) ? 'of your friends' : 'friend')
                  + ' to join you!';
          confirmation(null, message);
          SC.analytics.mp.logEvent('Challenge_Spring19 - Invite Friend ', 'navigation', {'Friends Invited': data.emails_sent});
          self.hide();
        } else if (data.invalid_emails) {
          for (var index in data.invalid_emails) {
            if (Object.prototype.hasOwnProperty.call(data.invalid_emails, index)) {
              var $input = self.$element
                .find('.invite-input-container .field-container:nth-child(' + (parseInt(index, 0) + 1) + ') input');
              self.fieldError($input, 'Invalid email');

              // Focus on the first error field
              if (Object.keys(data.invalid_emails)[0] === index) {
                $input.focus();
              }
            }
          }
        } else {
          self.hide();
          confirmation(null, data.error_message);
        }
      },
      error: function () {
        self.hide();
        confirmation($form, {'unknown': 'An unknown error has occurred'});
      }
    });
  };

  // Initialization
  this.init = function () {
    self = this;

    // Overlay event to hide dialog
    this.$element.click(function (e) {
      // Prevent this event from firing on child elements
      if (e.target === self.$element[0]) {
        self.hide();
      }
    });

    this.$close.click(function () {
      self.hide();
      SC.analytics.mp.sendEvent('Dismiss', 'navigation', {'Location': 'Challenge_Spring19 Invite'}, 'Challenge_Spring19 Invite');
    });

    this.$element.find('.invite-dismiss').click(function () {
      self.hide();
      SC.analytics.mp.logEvent('Challenge_Spring19 - Back to Dashboard', 'navigation', {'Location': 'Challenge_Spring19 Invite'});
    });

    // Set event for the login form submit event
    this.$element.find('form').submit(function (e) {
      e.preventDefault();
      self.submitForm();
    });

    // Add another invite input
    this.$element.find('.invite-add-container').click(function (e) {
      e.preventDefault();
      self.addEmailInput();
    });

    this.restoreDefaults();
  };

  this.init();
}
